<template>
    <q-page padding class=" column ">
        <div class="col-1">
            <h4 class="q-ma-xs">Проекты</h4>
        </div>
        <div class="col-11 row">
            <div class="col-12 col-sm-3 q-pa-sm">
                <q-list dense padding class="rounded-borders">
                    <q-item-label header>Категории</q-item-label>
                    <q-item-section>
                        <q-item clickable v-ripple v-for="projectType in           projectTypes          "
                            :key="projectType.id" @click="select(projectType)"
                            :active="projectType.id === selectedProjectType?.id" active-class="text-blue-8 bg-blue-3">
                            <q-item-section>{{ projectType.name }}</q-item-section>
                            <q-item-section side
                                v-if="permissions?.find(p => p.user.email === user.email)?.permission == 'ADMINISTRATOR'">
                                <q-btn flat icon="delete" @click="deleteProjectType(projectType)" />
                            </q-item-section>
                        </q-item>
                    </q-item-section>

                    <q-item clickable v-ripple @click="newProjectType = true">
                        <q-item-section avatar>
                            <q-icon name="add" />
                        </q-item-section>
                        <q-item-section>Новая категория</q-item-section>
                        <q-dialog v-model="newProjectType" persistent>
                            <new-project-type-form @add="add" @cancel="newProjectType = false"
                                :organization="organizationId" />
                        </q-dialog>
                    </q-item>
                </q-list>
            </div>
            <div class="col-12 col-sm-9">
                <div class="column q-gutter-y-md ">
                    <div class="col-1 row">

                    </div>
                    <div class="col-1">
                        <q-input v-model="search" filled dense />
                    </div>
                    <div class="col-10">
                        <projects-table ref="projectTable" :fetch="fetchProject" :search="searchTable" />
                    </div>
                </div>
            </div>
        </div>
    </q-page>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { StorageSerializers, useDebounce, useStorage } from "@vueuse/core";
import { useProjectTypesStore } from "../store/projectTypes";
import { storeToRefs } from "pinia";
import NewProjectTypeForm from "../components/NewProjectTypeForm.vue";
import ProjectsTable from "../components/ProjectsTable.vue";
import { useOrganizationProjectTypes, useOrganizationProjects } from "../composables/project";
import { useRouteParams } from "@vueuse/router";
import { useOrganizationUsers } from "../composables/organization";
import { useUserStore } from "../store/user";
import { ProjectType } from "../models/project";
import { useQuasar } from "quasar";

const $q = useQuasar()
const search = ref("")
const searchTable = useDebounce(search, 500)
const organizationId = useRouteParams('organizationId', undefined, { transform: Number })
const userStore = useUserStore()
const selectedProjectType = useStorage<ProjectType | null>(`${organizationId.value}_projectType`, null, undefined, { serializer: StorageSerializers.object })
const { user } = storeToRefs(userStore)
const projectTable = ref()
const store = useProjectTypesStore()

const { data: projectTypes, execute: fetchTypes } = useOrganizationProjectTypes(organizationId)

const { data: permissions } = useOrganizationUsers(organizationId)

const newProjectType = ref(false)

const fetchProject = computed(() => useOrganizationProjects(organizationId.value, selectedProjectType.value?.id))

const newProject = ref(false)
function select(projectType: ProjectType) {
    if (selectedProjectType.value?.id == projectType.id) {
        selectedProjectType.value = null

    } else {
        selectedProjectType.value = projectType
    }
    projectTable.value.fetch()
}

async function deleteProjectType(projectType: ProjectType) {
    $q.dialog({
        title: 'Удаление',
        message: 'Для удаления введите имя категории',
        prompt: {
            model: '',
            isValid: val => val === projectType?.name, // << here is the magic
            type: 'text' // optional
        },
        cancel: true,
        persistent: true
    }).onOk(async data => {
        if (data === projectType?.name) {
            await store.deleteType(projectType.id)
            await fetchTypes()
            selectedProjectType.value = null
        }

    })
}

async function add() {
    newProjectType.value = false
    await fetchTypes()
}
</script>

<style scoped></style>